// extracted by mini-css-extract-plugin
export var gif = "_lx-0";